import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasMany, references } from '@apexdesigner/schema-tools';

export const token = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    referenceNumber: z
      .number()
      .nullable()
      .optional()
      .describe('Human-readable reference number'),

    activityId: z
      .string()
      .nullable()
      .optional()
      .describe('Current activity where this token is located'),

    status: z
      .enum(['Active', 'Paused', 'Error', 'Complete'])
      .nullable()
      .optional()
      .describe('Current state of this token'),

    errorMessage: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Error details if the token encountered a problem'),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('createdAt'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('updatedAt'),

    processInstanceId: z
      .uuid()
      .hidden()
      .describe('Foreign key to ProcessInstance'),

    currentUserTaskId: z
      .uuid()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to UserTask'),

    currentServiceTaskId: z
      .uuid()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to ServiceTask'),

    currentChildProcessInstanceId: z
      .uuid()
      .nullable()
      .optional()
      .hidden()
      .describe('Foreign key to ProcessInstance'),

    processInstance: belongsTo('ProcessInstance'),

    currentUserTask: references('UserTask', 'currentUserTaskId'),

    currentServiceTask: references('ServiceTask', 'currentServiceTaskId'),

    currentChildProcessInstance: references(
      'ProcessInstance',
      'currentChildProcessInstanceId',
    ),

    userTasks: hasMany('UserTask', 'tokenId'),

    serviceTasks: hasMany('ServiceTask', 'tokenId'),

    childProcessInstances: hasMany('ProcessInstance', 'parentTokenId'),

    tokenHistories: hasMany('TokenHistory', 'tokenId'),

    downstreamLinks: hasMany('TokenLink', 'upstreamTokenId'),

    upstreamLinks: hasMany('TokenLink', 'downstreamTokenId'),

    timers: hasMany('Timer', 'tokenId'),

    messageListeners: hasMany('MessageListener', 'tokenId'),

    myUserTasks: hasMany('MyUserTask', 'tokenId'),
  })
  .describe('Tracks the current position in a process flow')
  .as('Token');

export { token as tokenSchema };
